export default __webpack_public_path__ + "static/media/edit.29251da5.svg";